import { ToggleButtonGroup, ToggleButton } from "@mui/material/";
import formInputs from "../formInputs";
import toggleSX from '../muiStyles/toggleSX.js'

const Introvert = ({ userData, handleUserChange }) => {
  return (
    <>
      
      <ToggleButtonGroup
        sx={{ justifyContent: "flex-start", display: "flex" }}
        exclusive
        name="introvertOptions"
        value={userData.introvertOptions}
        onChange={handleUserChange}
        className="introvertChoices groups"
      >
        <h4>Are you more introverted or extroverted?</h4>
        {formInputs.intovertedness.map((item) => (
          <ToggleButton
            name="introvertOptions"
            sx={toggleSX}
            className="toggles"
            key={item.id}
            value={item.name}
          >
            <p>{item.name}</p>
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </>
  );
};

export default Introvert;
